<i18n>
{
  "fr": {
    "folderNumber": "N° dossier :",
    "folderNumberOfConnection": "N° branchement neuf :",
    "modifyInformations": "Modifier la propriété",
    "propertyInfos": "Informations sur la propriété",
    "town": "Commune :",
    "zipCode": "Code postal :",
    "street": "Rue : ",
    "numberStreet": "N° Police : ",
    "typeOfProperty": "Type de propriété :",
    "creationDate": "Date de création :",
    "estimatedNumberOfResident":"Estimation du nombre d’équivalent habitant : ",
    "invalidBanAddress": "Attention cette adresse ne semble pas correcte"
    }
}
</i18n>
<template>
  <b-card
    :class="{ infoForm: !detail }"
    body-class="pd-15 mg-b-15"
    header-class="bg-transparent bd-b-1 pd-15"
    class="card-hover card-suze"
  >
    <template v-slot:header>
      <template v-if="title">
        <h2>
          {{ title }}
          <span class="sub-title">{{ $t('propertyInfos') }}</span>
        </h2>
        <h4></h4>
      </template>
      <template v-else>
        <h2>{{ $t('propertyInfos') }}</h2>
      </template>
      <div class="d-flex">
        <slot name="cancelbtn"></slot>
        <router-link
          class="btn btn-cta s-btn pull-right"
          :to="{ name: 'property_edit', params: { propertyId: propId } }"
          >{{ $t('modifyInformations') }}</router-link
        >
      </div>
    </template>
    <div class="row">
      <div class="col-6 text-left">
        <div :class="classObject">
          <p class="text">
            {{ $t('folderNumber') }}
            <span>{{ property.folderNumber }}</span>
          </p>
          <p v-if="!detail && !nbConnection" class="text">
            {{ $t('folderNumberOfConnection') }}
            <span v-if="property.conception">{{ property.conception.folderNumberOfConnection }}</span>
          </p>
          <p v-if="detail" class="text">
            {{ $t('typeOfProperty') }}
            <span v-if="property.propertyType">{{ getPropertyType(property.propertyType,property.propertyTypeOther) }}</span>
          </p>

          <p v-if="!detail && !nbConnection" class="text">
            {{ $t('folderNumberOfConnection') }}
            <span v-if="property.conception">{{ property.conception.folderNumberOfConnection }}</span>
          </p>
          <p v-if="detail" class="text">
            {{ $t('creationDate') }}
            <span v-if="property.creationDate">{{ property.creationDate | moment('DD/MM/YYYY') }}</span>
          </p>

          <p class="text">
            {{ $t('numberStreet') }}
            <span v-if="property.address">{{ property.address.numberStreet }}</span>
          </p>
        </div>
      </div>
      <div class="col-6 text-left">
        <div :class="classObject">
          <p class="text">
            {{ $t('street') }}
            <span v-if="property.address">{{ property.address.street }}</span>
          </p>
          <p class="text">
            {{ $t('town') }}
            <span v-if="property.address && towns.length > 0">{{
              getFullTextTown(property.address.town).toUpperCase()
            }}</span>
          </p>
          <p v-if="detail" class="text">
            {{ $t('zipCode') }}
            <span v-if="property.address">{{ property.address.zipCode }}</span>
          </p>
          <p v-if="detail" class="text">
            {{ $t('estimatedNumberOfResident') }}
            <span v-if="property.conception">{{ property.conception.estimatedNumberOfResident }}</span>
          </p>
        </div>
      </div>
      <div class="col-12 alert alert-danger text-center"
           v-if="false === property.isBanValid"
           role="alert"><span>{{ $t('invalidBanAddress') }}</span>
      </div>
    </div>
  </b-card>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'InfoBar',
  data() {
    return {
      propId: this.$route.params.propertyId,
    };
  },
  props: {
    detail: { type: Boolean, required: false, default: false },
    nbConnection: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: null },
  },
  computed: {
    ...mapState({ property: (state) => state.refProperties.property, towns: (state) => state.refProperties.towns }),
    classObject: function () {
      return {
        block: this.title && !this.error,
      };
    },
  },
  methods: {
    getFullTextTown(townCode) {
      townCode = townCode.toLowerCase();
      townCode = townCode.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      let town = this.towns.find((town) => town.code.toLowerCase() == townCode);
      let name = town.internalLabel.toLowerCase();
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`;
    },
    getPropertyType(propertyType, propertyTypeOther) {
      if (propertyType.code === 'autres') {
        return `${propertyType.internalLabel}, ${propertyTypeOther}`;
      } else {
        return propertyType.internalLabel;
      }
    },
  },
};
</script>
